import useConfiguratorData from "../../hooks/useConfiguratorData";
import useLeadData from "../../hooks/useLeadData";

/**
 * Selector de colores para el vehículo (versión nueva v2)
 * Permite cambiar el color y actualiza el lead automáticamente
 */
const ColorSelector = () => {
    const { getColors, getSelectedColor, setSelectedColor } = useConfiguratorData();
    const { updateLead } = useLeadData();

    const colors = getColors();
    const selectedColor = getSelectedColor();

    // Maneja el cambio de color y actualiza el lead
    const handleColorChange = (color) => {
        setSelectedColor(color);
        updateLead([{ name: "color", value: color.name }]);

        if(dataLayer) {
            dataLayer.push({
                'event': 'cotizador',
                'eventCategory': 'elige_un_color',
                'eventAction': 'cta',
                'eventLabel': color.name.replace(/\s+/g, '_').toLowerCase()
            });
            
        }
    };

    return (
        <div className="colors-container">
            {selectedColor ? (
                <>
                    <div className="component-header">
                        <h2>Elige un color</h2>
                    </div>
                    <div className="colors">
                        {colors.map((color) => (
                            <div className="color-item" key={`color-${color.id}`}>
                                <button
                                    className={selectedColor.id === color.id ? "active" : ""}
                                    onClick={() => handleColorChange(color)}
                                >
                                    <span
                                        className="circle"
                                        style={{ backgroundColor: color.hexcode }}
                                    ></span>
                                </button>
                                <small>{color.name}</small>
                            </div>
                        ))}
                    </div>
                    {selectedColor.disclaimer && (
                        <div className="component-legals">{selectedColor.disclaimer}</div>
                    )}
                </>
            ) : null}
        </div>
    );
};

export default ColorSelector;
